import { useSelector } from "store";
// material-ui
import Typography from "@mui/material/Typography";
import { AvatarProps } from "@mui/material/Avatar";
// project imports
import Avatar from "shared/ui/extended/Avatar";

// types
import { ThemeMode } from "shared/types/config";

// third-party
import { useIntl } from "react-intl";

//utils
import { userFullName } from "shared/utils/converters";

type FullName = {
  firstName: string;
  lastName: string;
  middleName: string | undefined;
};
type LocalizedAvatarProps = {
  avatar: string;
  fullName: FullName;
  size?: "badge" | "xs" | "sm" | "md" | "lg" | "xl";
  sx?: AvatarProps["sx"];
};
const LocalizedAvatar = ({
  avatar,
  fullName,
  size,
  sx,
}: LocalizedAvatarProps) => {
  const intl = useIntl();
  const { mode } = useSelector((state) => state.config);
  const { firstName, lastName, middleName } = fullName;
  const fullInitials = userFullName(firstName, lastName, middleName, true);
  const alt = fullInitials || intl.formatMessage({ id: "notFilledIn" });
  return (
    <Avatar alt={alt} sx={{ fontSize: 14, ...sx }} size={size}>
      <Typography
        sx={{
          color: mode === ThemeMode.DARK ? "primary.dark" : "primary.light",
          lineHeight: "40px",
        }}
      >
        {avatar}
      </Typography>
    </Avatar>
  );
};
export default LocalizedAvatar;
